// Divider.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './Divider.css';

/**
 * Divider Component
 * 
 * This component renders a divider.
 * 
 * @returns {ReactNode} The rendered component.
 */
const Divider = ({ direction = "horizontal", height = "100%", width = "100%", color, margin = "7px", marginTop = "0px", marginBottom = "0px" }) => {
  const resolvedMarginTop = marginTop ?? '0px';
  const resolvedMarginBottom = marginBottom ?? '0px';

  // ----- CONTEXT ----- //

  // Theme Context

  const { theme } = useTheme();

  const dividerColor = color ?? theme.outlineMuted;

  // ----- RENDER ----- //

  return (
    <>
      {direction === "vertical" ? (
        <div
          className="divider-container-vertical"
          style={{
            borderColor: dividerColor,
            height: height,
            marginLeft: margin,
            marginRight: margin,
            marginTop: resolvedMarginTop,
          }}
        > </div>
      ) : (
        <div
          className="divider-container-horizontal"
          style={{
            borderColor: dividerColor,
            marginBottom: resolvedMarginBottom,
            marginTop: resolvedMarginTop,
            width: width,
          }}
        ></div>
      )}
    </>
  );
};

// Dev Tools
Divider.displayName = 'Divider';

export default Divider;
